import React from 'react';
import _ from 'lodash';
import Promise from 'bluebird';
import LoadingSpinner from 'shared/components/ui/loadingSpinner';
import FormField from 'scy/FormField';
import PhoneInput from 'shared/components/phoneInput';
import { DangerText } from 'scy/text';
import { LoadingButton } from 'scy/buttons';
import {
  validEmail,
  formatBirthday,
  displayBirthday
} from 'shared/models/user';
import margin from 'scy/margin.mod.scss';
import { width100 } from 'scy/utils.mod.scss';

export default class AccountDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errors: {},
      loading: false,
      success: false,
      firstname: props.user.firstname,
      lastname: props.user.lastname,
      email: props.user.email,
      mobile: props.user.mobile,
      birthday: props.user.birthday
    };
  }

  validateFirstname(name) {
    if (_.isEmpty(name)) return "First Name can't be blank";
  }

  validateLastname(name) {
    if (_.isEmpty(name)) return "Last Name can't be blank";
  }

  validateEmail(email) {
    if (!validEmail(email)) return 'Email is not valid';
  }

  validateFields() {
    const { firstname, lastname, email, mobile } = this.state;

    let errors = {};
    errors.firstname = this.validateFirstname(firstname) || null;
    errors.lastname = this.validateLastname(lastname) || null;
    errors.email = this.validateEmail(email) || null;

    if (this.validateMobile) {
      errors.mobile = this.validateMobile(mobile) || null;
    }

    this.setState({ errors });

    if (_.some(errors)) return Promise.reject(new Error());
    return Promise.resolve();
  }

  _submit() {
    const data = {
      firstname: this.state.firstname.trim(),
      lastname: this.state.lastname.trim(),
      email: this.state.email.trim(),
      mobile: this.state.mobile.trim(),
      birthday: formatBirthday(this.state.birthday)
    };

    return this.props.updateUser(data);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true, success: false, error: null });
    this.validateFields()
      .then(() => this._submit())
      .then(() => this.setState({ loading: false, success: true }))
      .catch(({ message }) => {
        if (typeof message === 'object' && typeof message.reason === 'object') {
          this.setState({ loading: false, errors: message.reason });
        } else {
          this.setState({ loading: false, error: message });
        }
      });
  }

  render() {
    const user = this.props.user;
    if (!user) return null;

    const disabled = !user.mobileVerified;

    return (
      <form onSubmit={e => this.handleSubmit(e)}>
        {this.state.loading && <LoadingSpinner green />}

        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <FormField
              id="user-first-name"
              name="fname"
              labelText="First Name"
              initialValue={user.firstname}
              updatedValue={this.state.firstname}
              onChange={firstname => this.setState({ firstname })}
              validate={firstname => this.validateFirstname(firstname)}
              error={this.state.errors.firstname}
              disabled={disabled}
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            <FormField
              id="user-last-name"
              name="lname"
              labelText="Last Name"
              initialValue={user.lastname}
              updatedValue={this.state.lastname}
              onChange={lastname => this.setState({ lastname })}
              validate={lastname => this.validateLastname(lastname)}
              error={this.state.errors.lastname}
              disabled={disabled}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <FormField
              id="user-email"
              name="email"
              labelText="Email"
              inputType="email"
              initialValue={user.email}
              updatedValue={this.state.email}
              onChange={email => this.setState({ email })}
              validate={email => this.validateEmail(email)}
              error={this.state.errors.email}
              disabled={disabled}
            />
          </div>

          <div className="col-xs-12 col-sm-6">
            <PhoneInput
              initialValue={user.mobile}
              onChange={mobile =>
                this.setState(state => ({
                  mobile,
                  errors: {
                    ...state.errors,
                    mobile: null
                  }
                }))
              }
              forwardValidator={validate => (this.validateMobile = validate)}
              error={this.state.errors.mobile}
              disabled={disabled}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <FormField
              id="user-birthday"
              name="birthday"
              labelText="Birthday"
              marginClass={disabled ? margin.bottom_0 : margin.bottom_md}
              placeholder="mm/dd/yyyy"
              disabled
              mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
              inputType="tel"
              initialValue={displayBirthday(user.birthday)}
            />
          </div>
        </div>

        {this.state.error && (
          <DangerText className={margin.bottom_sm}>
            {this.state.error}
          </DangerText>
        )}

        {!disabled && (
          <div className="row">
            <div className="col-xs-10 col-xs-offset-1 col-sm-3 col-sm-offset-0">
              <LoadingButton
                type="submit"
                loading={this.state.loading}
                className={width100}
              >
                Save
              </LoadingButton>
            </div>
          </div>
        )}
      </form>
    );
  }
}
